// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__14gWZ","ranges":"BmiRanges_ranges__2-yVf"};